export const getCountriesApi = async (search = '') => {
  const response = await fetch(`https://restcountries.com/v3.1/name/${search || 'a'}?fields=name,currencies`);
  const data = await response.json();
  return data.slice(0, 10).map(country => ({
    name: country.name.common,
    currency: Object.keys(country.currencies || {})[0] || 'USD'
  }));
};

export const getAllCountriesApi = async () => {
  const response = await fetch('https://restcountries.com/v3.1/all?fields=name,currencies');
  const data = await response.json();
  return data.slice(0, 10).map(country => ({
    name: country.name.common,
    currency: Object.keys(country.currencies || {})[0] || 'USD'
  }));
};